var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-btn',{staticClass:"mb-3",attrs:{"bottom":"","show-tooltip":"","color":"lightBlue","outlined":""},on:{"click":_vm.restore}},[_vm._v(" Restore default view ")])}
var staticRenderFns = []

export { render, staticRenderFns }